import { Skeleton } from "../../../components/shadcn";

export default function PropertySkeleton() {
  return (
    <div className="w-full max-w-md overflow-hidden rounded-lg border border-gray-300 bg-white shadow">
      {/* Property image skeleton */}
      <div className="relative">
        <Skeleton className="h-[150px] w-full" />
        {/* Badge skeleton */}
        <div className="absolute left-0 top-0 flex">
          <Skeleton className="h-10 w-16 rounded-none bg-gray-200" />
          <Skeleton className="h-10 w-32 rounded-r-lg bg-gray-100" />
        </div>
      </div>

      {/* Property details */}
      <div className="p-4 space-y-4">
        {/* Address and contacts */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-7 w-3/5" />
          <Skeleton className="h-5 w-24" />
        </div>

        {/* Owner name */}
        <Skeleton className="h-6 w-40" />

        {/* Property features */}
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-center space-x-1">
            <Skeleton className="h-5 w-5" />
            <Skeleton className="h-5 w-16" />
          </div>

          <div className="flex items-center space-x-1">
            <Skeleton className="h-5 w-5" />
            <Skeleton className="h-5 w-16" />
          </div>

          <div className="flex items-center space-x-1">
            <Skeleton className="h-5 w-5" />
            <Skeleton className="h-5 w-24" />
          </div>

          <div className="flex items-center space-x-1">
            <Skeleton className="h-5 w-5" />
            <Skeleton className="h-5 w-24" />
          </div>
        </div>
      </div>
    </div>
  )
}
